import { createRoute } from "@tanstack/solid-router";
import { lazy, Suspense } from "solid-js";
import { appRoute } from "./route";

const FinanceSettingsPage = lazy(async () => {
  const m = await import("@/features/finance/components/finance-settings-page");
  return { default: m.FinanceSettingsPage };
});

function FinanceSettingsPageWrapper() {
  return (
    <Suspense fallback={null}>
      <FinanceSettingsPage />
    </Suspense>
  );
}

function sanitizeFinanceSettingsSearch(search: Record<string, unknown>): {
  pin?: "setup" | "change" | "disable";
} {
  const p = search.pin;
  return { pin: p === "setup" || p === "change" || p === "disable" ? p : undefined };
}

export const financeSettingsRoute = createRoute({
  getParentRoute: () => appRoute,
  path: "/settings/finance",
  // Addressable PIN dialog: `?pin=setup|change|disable`.
  validateSearch: sanitizeFinanceSettingsSearch,
  component: FinanceSettingsPageWrapper,
});
